/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Review_TitleInputs */

const en_ticket_review_title = /** @type {(inputs: Ticket_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the field engineer`)
};

const ja_ticket_review_title = /** @type {(inputs: Ticket_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術者を評価する`)
};

const fr_ticket_review_title = /** @type {(inputs: Ticket_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évaluer le technicien`)
};

const de_ticket_review_title = /** @type {(inputs: Ticket_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicetechniker bewerten`)
};

/**
* | output |
* | --- |
* | "Review the field engineer" |
*
* @param {Ticket_Review_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_review_title = /** @type {((inputs?: Ticket_Review_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Review_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_review_title(inputs)
	if (locale === "ja") return ja_ticket_review_title(inputs)
	if (locale === "fr") return fr_ticket_review_title(inputs)
	return de_ticket_review_title(inputs)
});